<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
//eslint-disable-next-line
import ValidationChecks from "../../../../src/components/validation-checks/validation-checks.vue";
/**
 * Starter component
 */
export default {
    page: {
        title: "Validation Checks",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, ValidationChecks },
    data() {
        return {
            title: "Validation & Checks",
            items: [
                // {
                //     text: "Clients",
                //     href: "/clients",
                // },
            ],
        };
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ValidationChecks />
    </Layout>
</template>
